import api from '../api/axios';

const faixasDefesaService = {
  async listarPadrao(organizadorId) {
    const { data } = await api.get(`/organizadores/${organizadorId}/faixas-defesa`);
    return data;
  },

  async salvarPadrao(organizadorId, faixas) {
    const { data } = await api.put(`/organizadores/${organizadorId}/faixas-defesa`, faixas);
    return data;
  },

  async listarPorLeilao(organizadorId, leilaoId) {
    const { data } = await api.get(`/organizadores/${organizadorId}/leiloes/${leilaoId}/faixas-defesa`);
    return data;
  },

  async salvarPorLeilao(organizadorId, leilaoId, faixas) {
    const { data } = await api.put(`/organizadores/${organizadorId}/leiloes/${leilaoId}/faixas-defesa`, faixas);
    return data;
  },

  async removerOverrideLeilao(organizadorId, leilaoId) {
    const { data } = await api.delete(`/organizadores/${organizadorId}/leiloes/${leilaoId}/faixas-defesa`);
    return data;
  },
};

export default faixasDefesaService;
